module.exports = __webpack_public_path__ + "img/SC-5999.5bb71ba1.png";